<div class="banner justify-content-center" role="banner">
  <h1 class="text-white">{{ 'faq.page.title' | translate }}</h1>
</div>

<div class="container">
  <fgbcl-faq-section></fgbcl-faq-section>
</div>
